import { defineComponent as _defineComponent } from 'vue'
import { computed, del, ref, set, watch } from 'vue';

import RangeInput from '@/ui-components/RangeInput.vue';
import ResetButton from '@/components/buttons/ResetButton.vue';

import { FilterCollection } from '@/stores/filter.store';
import { FormattedScoring, SCORINGS } from '@/helpers/scoring-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { CollectionType } from '../../enums/collection-type';
import { useFilterStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterRating',
  props: {
    collectionType: null,
    currentFilters: null
  },
  setup(__props: any) {

const props = __props as {
	collectionType: CollectionType;
	currentFilters: FilterCollection;
};



const { setFilterValue } = useFilterStore();
const rangeRefs = ref<{ [key: string]: number }>({});

const scorings = computed<FormattedScoring[]>(() => {
	const scoringFilters = props.currentFilters.scoring_filter_types || {};

	return SCORINGS.filter(scoring => scoring.filterDisplay).map(scoring => {
		const scoreFilter = scoringFilters[scoring.provider];
		const value = scoreFilter?.min_scoring_value ?? 0;

		return {
			...scoring,
			value: round(value),
		};
	});
});

watch(
	scorings,
	newScorings => {
		const newProviders = new Set<string>();

		for (const scoring of newScorings) {
			newProviders.add(scoring.provider);
			if (rangeRefs.value[scoring.provider] !== scoring.value) {
				set(rangeRefs.value, scoring.provider, scoring.value);
			}
		}

		Object.keys(rangeRefs.value).forEach(p => {
			if (!newProviders.has(p)) del(rangeRefs.value, p);
		});
	},
	{ deep: true, immediate: true }
);

/**
 * the range slider has changed and needs to update the store as well.
 */
function changed(scoring: FormattedScoring, val: number) {
	const value = round(val);
	set(rangeRefs.value, scoring.provider, round(value));

	const filterValue = {
		...props.currentFilters.scoring_filter_types,
		[scoring.provider]: {
			min_scoring_value: value,
		},
	};
	if (value === scoring.min) {
		delete filterValue[scoring.provider];
	}
	setFilterValue({
		filterName: 'scoring_filter_types',
		filterValue: Object.keys(filterValue).length ? filterValue : null,
	});

	TrackingHelper.trackEvent('userinteraction', {
		action: 'filter_toggled',
		label: 'scoring_filter_types',
	});
}

function round(rating: number) {
	return Math.round(rating * 10) / 10;
}

return { __sfc: true,props, setFilterValue, rangeRefs, scorings, changed, round, RangeInput, ResetButton }
}

})